import { render, staticRenderFns } from "./formPrinter.vue?vue&type=template&id=0c716826&"
import script from "./formPrinter.vue?vue&type=script&lang=js&"
export * from "./formPrinter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports